<script setup lang="ts">
import { ref } from "vue";
import { appContainer } from "../../container";
import { ErrorResponse } from "../../interface/ErrorInterface";
import { LoadingService } from "../../services/loadingService";
import { ResourceService } from "../../services/resourceService";
import { ToastService } from "../../services/toastService";
import { AxiosError } from "axios";

import ValidationErrorComponent from "../../components/ValidationErrorComponent.vue";

const props = defineProps<{
  resourceId: number;
}>();

const emit = defineEmits(["close", "delete"]);

const loadingService = appContainer.resolve(LoadingService);
const toastService = appContainer.resolve(ToastService);
const resourceService = appContainer.resolve(ResourceService);

const validationErrors = ref<ErrorResponse>();
async function deleteResourceFile() {
  const loader = await loadingService.show();

  resourceService
    .deleteResource(props.resourceId)
    .then(() => {
      toastService.success("Resource Deleted Successfully");
      emit("delete");
    })
    .catch((err) => {
      const error = err as AxiosError;
      const errorResponse = error.response?.data as any;
      validationErrors.value = {
        errors: {
          delete: [errorResponse.message],
        },
      };
    })
    .finally(() => loader.hide());
}
</script>

<template>
  <div class="modal-backdrop">
    {{ props.resourceId }}
    <div class="modal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body pt-5">
            <ValidationErrorComponent
              v-if="validationErrors"
              :validations="validationErrors"
            ></ValidationErrorComponent>
            <h5 class="ff-montserrat text-center m-0">
              Do you want to delete this file?
            </h5>
            <div class="d-flex justify-content-center p-4">
              <button
                type="button"
                class="btn btn-outline-primary mx-3"
                @click="emit('close')"
              >
                Cancel
              </button>
              <button
                type="button"
                class="btn btn-danger text-white mx-3"
                @click="deleteResourceFile"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
button {
  &:hover {
    color: #fff;
  }
}
</style>
